module.exports = __webpack_public_path__ + "a0654e6531f06aa1067725f3f70e345b.pdf";